<template>
  <div
    v-if="!isLoading"
    class="page-rw"
  >
    <div class="rw">
      <div class="filters">
        <custom-date-picker
          v-model="dateRange"
          :range="true"
          placeholder="Select date range"
          class="date-range"
        >
          <div slot="label">
            Time period
          </div>
        </custom-date-picker>
        <div class="tags">
          <rw-tag :num="4">
            Location
          </rw-tag>
          <rw-tag :num="70">
            Supplier
          </rw-tag>
          <rw-tag :num="3">
            Status
          </rw-tag>
        </div>
        <filter-btn />
        <div class="vertical-separator" />
        <menu-btn />
      </div>
      <section class="summary">
        <div class="summary-data">
          <div class="col">
            <div class="title">
              Bookings Summary
            </div>
            <table>
              <tr>
                <td>Number of Booking</td>
                <td>489 413</td>
              </tr>
              <tr class="separator">
                <td>Monetary $ Value</td>
                <td class="grow">
                  <span>$105.58M</span>
                </td>
              </tr>
              <tr>
                <td>Number of Cancellations</td>
                <td>111 583</td>
              </tr>
              <tr class="separator">
                <td>Cancellations $ Value</td>
                <td>$15.5M</td>
              </tr>
              <tr>
                <td>Profit $ Value</td>
                <td>11.14 M$</td>
              </tr>
            </table>
          </div>
          <div class="col">
            <div class="title">
              Post Booking Optimzation
            </div>
            <table>
              <tr>
                <td>Total Profit increase</td>
                <td class="grow">
                  <span>$417,905.09</span>
                </td>
              </tr>
              <tr class="separator">
                <td>Avg. Profit Increase</td>
                <td>$55.03</td>
              </tr>
              <tr>
                <td>Total Evaluation Uptake</td>
                <td>$1,131.06</td>
              </tr>
              <tr class="separator">
                <td>Avg. Evaluation Uptake</td>
                <td>$75.40</td>
              </tr>
            </table>
          </div>
        </div>
        <section class="chart">
          <div class="title">
            Price over time
          </div>
          <div class="chart-wrapper">
            <line-chart class="line-chart" />

          </div>
        </section>
      </section>
    </div>
    <section class="orders-wrapper">
      <rw-orders-table
        :rows="preparedOrders"
      />
    </section>
  </div>
</template>
<script>
import CustomDatePicker from '../components/tiny/CustomDatePicker';
import RwTag from '../components/tiny/RwTag';
import FilterBtn from '../components/tiny/FilterBtn';
import MenuBtn from '../components/tiny/MenuBtn';
import LineChart from '../components/RwChart.vue';
import RwOrdersTable from '../components/RwOrdersTable';

// This is the only page that doesn't use data-convert and should be updated separately in data/manage-orders.js
import { rwOrders } from '../data/manage-orders';

export default {
  name: 'page-rw',
  components: {
    CustomDatePicker,
    RwTag,
    FilterBtn,
    MenuBtn,
    LineChart,
    RwOrdersTable,
  },
  data() {
    return {
      isLoading: false,
      rwOrders,
      dateRange: [
        new Date('Wed Jan 01 2020 00:00:00 GMT+0200 (Eastern European Standard Time)'),
        new Date('Sun Jul 05 2020 00:00:00 GMT+0300 (Eastern European Summer Time)'),
      ],
    };
  },
  computed: {
    preparedOrders() {
      const preparedOrders = [];

      this.rwOrders.forEach(order => {
        const newOrder = { ...order };
        preparedOrders.push(newOrder);
      });

      return preparedOrders;
    },
  },
};
</script>

<style scoped lang="scss">
.rw {
  padding: 20px 28px;
}
.filters {
  display: flex;
  align-items: center;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(#6e7c91, .07);
}
.date-range {
  padding: 10px 20px 10px 0;
  border-right: 1px solid rgba(#6e7c91, .07);
}
.vertical-separator {
  display: inline-block;
  width: 1px;
  height: 58px;
  margin: 0 8px;
  background-color: rgba(#6e7c91, .07);
}
.tags {
  padding-left: 20px;
  flex-grow: 1;
  .tag {
    &:not(:last-child) {
      margin-right: 10px;
    }
  }
}
.summary {
  display: flex;
  justify-content: space-between;
  @media screen and (max-width: 1200px) {
    flex-direction: column;
  }
  .chart {
    width: calc(100% * 3 / 7);
    margin-top: 22px;
    .line-chart {
      height: 220px;
    }
    @media screen and (max-width: 1200px) {
      width: auto;
    }
  }
  &-data {
    width: calc(100% * 4 / 7);
    margin-right: 48px;
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    padding: 10px 0;
    .col {
      margin: 12px 48px;
      flex: 1;
      &:first-child {margin-left: 0 !important;}
      &:last-child {margin-right: 0 !important;}
    }

    @media screen and (max-width: 1600px) {
      margin-right: 24px;
      .col {margin: 12px 24px;}
    }
    @media screen and (max-width: 1280px) {
      width: auto;
    }

    .title {
      color: #6e7c91;
      font-size: 15px;
      font-weight: 700;
      margin-bottom: 8px;
    }

    table {
      width: 100%;
      tr.separator {
        border-bottom: 1px solid rgba(#6e7c91, .07);

        td {
          padding-bottom: 8px;

          &.grow {
            padding-bottom: 4px;
          }
        }

        & + tr {
          td {
            padding-top: 8px;

            &.grow {
              padding-top: 4px;
            }
          }
        }
      }
      td {
        color: #6e7c91;
        font-size: 14px;
        font-weight: 500;
        padding-top: 6px;
        padding-bottom: 6px;
        padding-right: 32px;

        &:nth-child(even) {
          text-align: right;
          padding-right: 8px;
          padding-left: 32px;
          font-weight: 700;
        }

        &.grow {
          padding-top: 2px;
          padding-bottom: 2px;

          span {
            display: inline-block;
            white-space: nowrap;
            margin-left: 18px;
            background-color: rgba(#17cd53, .2);
            position: relative;
            color: #3cbf68;
            font-size: 13px;
            font-weight: 700;
            border-radius: 3px;
            padding: 4px 8px;
            margin-right: -8px;

            &::before {
              content: '';
              display: inline-block;
              position: absolute;
              top: 50%;
              left: -12px;
              transform: translateY(-50%);
              width: 6px;
              height: 8px;
              background-image: url('../assets/icons/arrow-up-green.png');
              background-repeat: no-repeat;
              background-size: contain;
            }
          }
        }
      }
    }
  }
}

.chart {
  margin-bottom: 32px;
  max-width: 100%;
  overflow: hidden;
  position: relative;

  .chart-wrapper {
    height: 180px;
    position: relative;
    & > .line-chart {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      height: 100%;
    }
  }

  .title {
    margin-bottom: 16px;
    color: #6e7c91;
    font-size: 15px;
    font-weight: 700;
  }
}
.orders-wrapper {
  padding: 28px;
  background-color: #fff;
  max-width: 100%;
  overflow: auto;
}
</style>
